import { render, staticRenderFns } from "./MP3Recorder.vue?vue&type=template&id=7bf19c6a&scoped=true"
import script from "./MP3Recorder.vue?vue&type=script&lang=js"
export * from "./MP3Recorder.vue?vue&type=script&lang=js"
import style0 from "./MP3Recorder.vue?vue&type=style&index=0&id=7bf19c6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf19c6a",
  null
  
)

export default component.exports